var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input',_vm._b({attrs:{"disabled":_vm.disabled},on:{"input":_vm.digitalCorrection,"change":_vm.onChange},model:{value:(_vm.proxyNumeric),callback:function ($$v) {_vm.proxyNumeric=$$v},expression:"proxyNumeric"}},'el-input',_vm.$attrs,false),[_c('template',{slot:_vm.slotType},[_vm._v(" "+_vm._s(_vm.slotData)+" ")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }